import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { FlagIcon } from './UI';
export const Footer = () => {
  const [showShippingPolicy, setShowShippingPolicy] = useState(false);
  const [showWarrantyPolicy, setShowWarrantyPolicy] = useState(false);
  const [showReturnsPolicy, setShowReturnsPolicy] = useState(false);
  const [showContactPolicy, setShowContactPolicy] = useState(false);
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const [showTermsPolicy, setShowTermsPolicy] = useState(false);
  return <footer className="bg-[#0a0a0a] border-t border-dark-3" data-id="element-179">
      {/* Shipping Policy Modal */}
      <AnimatePresence data-id="element-180">
        {showShippingPolicy && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6" data-id="element-181">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setShowShippingPolicy(false)} className="absolute inset-0 bg-black/80 backdrop-blur-sm" data-id="element-182" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="relative w-full max-w-3xl max-h-[85vh] bg-dark-1 border border-dark-3 shadow-2xl flex flex-col" data-id="element-183">
              {/* Modal Header */}
              <div className="flex items-center justify-between p-6 border-b border-dark-3 bg-base-black" data-id="element-184">
                <h2 className="font-bebas text-3xl text-white tracking-wider" data-id="element-185">
                  SHIPPING POLICY
                </h2>
                <button onClick={() => setShowShippingPolicy(false)} className="text-text-dimmed hover:text-acid-green transition-colors" data-id="element-186">
                  <X size={24} data-id="element-187" />
                </button>
              </div>

              {/* Modal Body */}
              <div className="p-6 overflow-y-auto font-inter text-sm text-text-dimmed leading-relaxed space-y-6 custom-scrollbar" data-id="element-188">
                <p data-id="element-189">
                  <strong data-id="element-190">Effective Date:</strong> May 18, 2024
                </p>
                <p data-id="element-191">
                  Welcome to BLACKOUT UNIT. This Shipping Policy explains how
                  orders are processed, shipped, and delivered when you purchase
                  from our store. By placing an order with BLACKOUT UNIT, you
                  agree to the terms below.
                </p>

                <div data-id="element-192">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-193">
                    ORDER PROCESSING
                  </h3>
                  <ul className="list-disc pl-5 space-y-2" data-id="element-194">
                    <li data-id="element-195">
                      All orders are processed within 24 hours after the order
                      is successfully placed and payment is verified.
                    </li>
                    <li data-id="element-196">
                      Orders placed after business hours, on weekends, or on
                      holidays may be processed on the next business day.
                    </li>
                  </ul>
                  <p className="mt-2" data-id="element-197">Please note:</p>
                  <ul className="list-disc pl-5 space-y-2" data-id="element-198">
                    <li data-id="element-199">
                      Processing time is separate from shipping transit time.
                    </li>
                    <li data-id="element-200">
                      Orders may be delayed for fraud prevention review, payment
                      verification, inventory checks, or address confirmation.
                    </li>
                    <li data-id="element-201">
                      BLACKOUT UNIT reserves the right to cancel or hold any
                      order suspected of fraud or unauthorized activity.
                    </li>
                  </ul>
                </div>

                <div data-id="element-202">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-203">
                    SHIPPING TIMEFRAME
                  </h3>
                  <ul className="list-disc pl-5 space-y-2" data-id="element-204">
                    <li data-id="element-205">Orders are shipped via USPS.</li>
                    <li data-id="element-206">
                      Estimated delivery time is typically 3–5 business days
                      after the order has been processed and shipped.
                    </li>
                  </ul>
                  <p className="mt-2" data-id="element-207">
                    Please understand that shipping timelines are estimates only
                    and are not guaranteed. Delivery times may be affected by:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-208">
                    <li data-id="element-209">Carrier delays</li>
                    <li data-id="element-210">Weather conditions</li>
                    <li data-id="element-211">High shipping volume</li>
                    <li data-id="element-212">Holidays</li>
                    <li data-id="element-213">Customs processing</li>
                    <li data-id="element-214">Natural disasters</li>
                    <li data-id="element-215">Incorrect shipping information</li>
                    <li data-id="element-216">Circumstances outside of our control</li>
                  </ul>
                  <p className="mt-2" data-id="element-217">
                    BLACKOUT UNIT is not responsible for delays caused by USPS
                    or other carrier-related issues once the package has been
                    shipped.
                  </p>
                </div>

                <div data-id="element-218">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-219">
                    TRACKING INFORMATION
                  </h3>
                  <ul className="list-disc pl-5 space-y-2" data-id="element-220">
                    <li data-id="element-221">
                      Tracking information will be sent to the email provided at
                      checkout once the order has shipped.
                    </li>
                    <li data-id="element-222">
                      Please allow up to 24 hours for tracking updates to appear
                      within the carrier’s system.
                    </li>
                  </ul>
                </div>

                <div data-id="element-223">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-224">
                    SHIPPING ADDRESS RESPONSIBILITY
                  </h3>
                  <p data-id="element-225">
                    Customers are responsible for entering the correct shipping
                    address at checkout. BLACKOUT UNIT is not responsible for:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-226">
                    <li data-id="element-227">Incorrect addresses entered by customers</li>
                    <li data-id="element-228">Failed deliveries</li>
                    <li data-id="element-229">Returned shipments</li>
                    <li data-id="element-230">
                      Packages delivered to the address provided during checkout
                    </li>
                  </ul>
                  <p className="mt-2" data-id="element-231">
                    If a package is returned due to an incorrect or insufficient
                    address, additional shipping charges may apply before
                    reshipment.
                  </p>
                </div>

                <div data-id="element-232">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-233">
                    LOST, STOLEN, OR DELIVERED PACKAGES
                  </h3>
                  <p data-id="element-234">
                    Once a package has been transferred to USPS and marked as
                    shipped, BLACKOUT UNIT is no longer responsible for
                    carrier-related delivery issues. BLACKOUT UNIT is not liable
                    for:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-235">
                    <li data-id="element-236">Lost packages</li>
                    <li data-id="element-237">Stolen packages</li>
                    <li data-id="element-238">Delayed packages</li>
                    <li data-id="element-239">Packages marked as “Delivered”</li>
                    <li data-id="element-240">Carrier mishandling</li>
                  </ul>
                  <p className="mt-2" data-id="element-241">
                    Customers must contact USPS directly regarding delivery
                    disputes or carrier claims.
                  </p>
                </div>

                <div data-id="element-242">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-243">
                    SHIPPING FEES
                  </h3>
                  <p data-id="element-244">
                    Shipping fees are calculated at checkout and are
                    non-refundable once the order has shipped.
                  </p>
                </div>

                <div data-id="element-245">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-246">
                    INTERNATIONAL SHIPPING
                  </h3>
                  <p data-id="element-247">If international shipping is offered:</p>
                  <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-248">
                    <li data-id="element-249">
                      Customers are responsible for all customs duties, taxes,
                      import fees, and VAT charges.
                    </li>
                    <li data-id="element-250">
                      BLACKOUT UNIT is not responsible for customs delays or
                      seizures.
                    </li>
                  </ul>
                </div>

                <div data-id="element-251">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-252">
                    REFUSED OR RETURNED SHIPMENTS
                  </h3>
                  <p data-id="element-253">
                    If an order is refused, unclaimed, or returned to sender,
                    BLACKOUT UNIT reserves the right to deduct:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-254">
                    <li data-id="element-255">Original shipping costs</li>
                    <li data-id="element-256">Return shipping fees</li>
                    <li data-id="element-257">Restocking fees (if applicable)</li>
                  </ul>
                  <p className="mt-2" data-id="element-258">before issuing any refund.</p>
                </div>

                <div data-id="element-259">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-260">
                    LIMITATION OF LIABILITY
                  </h3>
                  <p data-id="element-261">
                    To the fullest extent permitted by law, BLACKOUT UNIT shall
                    not be liable for:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-262">
                    <li data-id="element-263">Shipping delays</li>
                    <li data-id="element-264">Carrier errors</li>
                    <li data-id="element-265">Delivery failures</li>
                    <li data-id="element-266">Lost profits</li>
                    <li data-id="element-267">Indirect or consequential damages</li>
                    <li data-id="element-268">Events beyond our reasonable control</li>
                  </ul>
                  <p className="mt-2" data-id="element-269">
                    Our maximum liability shall never exceed the purchase price
                    of the product ordered.
                  </p>
                </div>

                <div data-id="element-270">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-271">
                    POLICY CHANGES
                  </h3>
                  <p data-id="element-272">
                    BLACKOUT UNIT reserves the right to update or modify this
                    Shipping Policy at any time without prior notice.
                  </p>
                </div>

                <div data-id="element-273">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-274">
                    CONTACT
                  </h3>
                  <p data-id="element-275">
                    BLACKOUT UNIT Customer Support:{' '}
                    <a href="mailto:support@blackoutunit.com" className="text-acid-green hover:underline" data-id="element-276">
                      support@blackoutunit.com
                    </a>
                  </p>
                </div>
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>

      {/* Warranty Policy Modal */}
      <AnimatePresence data-id="element-277">
        {showWarrantyPolicy && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6" data-id="element-278">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setShowWarrantyPolicy(false)} className="absolute inset-0 bg-black/80 backdrop-blur-sm" data-id="element-279" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="relative w-full max-w-3xl max-h-[85vh] bg-dark-1 border border-dark-3 shadow-2xl flex flex-col" data-id="element-280">
              {/* Modal Header */}
              <div className="flex items-center justify-between p-6 border-b border-dark-3 bg-base-black" data-id="element-281">
                <h2 className="font-bebas text-3xl text-white tracking-wider" data-id="element-282">
                  WARRANTY POLICY
                </h2>
                <button onClick={() => setShowWarrantyPolicy(false)} className="text-text-dimmed hover:text-acid-green transition-colors" data-id="element-283">
                  <X size={24} data-id="element-284" />
                </button>
              </div>

              {/* Modal Body */}
              <div className="p-6 overflow-y-auto font-inter text-sm text-text-dimmed leading-relaxed space-y-6 custom-scrollbar" data-id="element-285">
                <p data-id="element-286">
                  <strong data-id="element-287">Effective Date:</strong> May 18, 2026
                </p>
                <p data-id="element-288">
                  At BLACKOUT UNIT, we stand behind the quality of our products
                  and are committed to ensuring customer satisfaction. This
                  Warranty Policy outlines the terms, limitations, and
                  conditions applicable to products purchased through our
                  website.
                </p>
                <p data-id="element-289">
                  By purchasing from BLACKOUT UNIT, you acknowledge and agree to
                  the terms set forth below.
                </p>

                <div data-id="element-290">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-291">
                    LIMITED PRODUCT WARRANTY
                  </h3>
                  <ul className="list-disc pl-5 space-y-2" data-id="element-292">
                    <li data-id="element-293">
                      BLACKOUT UNIT provides a limited warranty covering
                      manufacturing defects in materials or workmanship under
                      normal and intended use.
                    </li>
                    <li data-id="element-294">
                      This warranty applies only to the original purchaser and
                      only to products purchased directly from BLACKOUT UNIT or
                      our authorized sales channels.
                    </li>
                  </ul>
                </div>

                <div data-id="element-295">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-296">
                    WARRANTY PERIOD
                  </h3>
                  <p data-id="element-297">
                    Unless otherwise stated on the product page, the standard
                    warranty period is:
                  </p>
                  <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-298">
                    <li data-id="element-299">30 days from the date of delivery</li>
                  </ul>
                  <p className="mt-2" data-id="element-300">
                    The warranty period begins on the date the carrier marks the
                    package as delivered.
                  </p>
                </div>

                <div data-id="element-301">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-302">
                    WHAT IS COVERED
                  </h3>
                  <p data-id="element-303">This limited warranty covers:</p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-304">
                    <li data-id="element-305">Manufacturing defects</li>
                    <li data-id="element-306">Defective materials</li>
                    <li data-id="element-307">Workmanship defects under normal use</li>
                    <li data-id="element-308">Product failures caused by verified factory defects</li>
                  </ul>
                  <p className="mt-2" data-id="element-309">
                    If BLACKOUT UNIT determines that a product qualifies under
                    this warranty, we may, at our sole discretion:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-310">
                    <li data-id="element-311">Repair the item</li>
                    <li data-id="element-312">Replace the item</li>
                    <li data-id="element-313">Issue store credit</li>
                    <li data-id="element-314">Issue a partial or full refund</li>
                  </ul>
                </div>

                <div data-id="element-315">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-316">
                    WHAT IS NOT COVERED
                  </h3>
                  <p data-id="element-317">This warranty does not cover:</p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-318">
                    <li data-id="element-319">Normal wear and tear</li>
                    <li data-id="element-320">Cosmetic damage</li>
                    <li data-id="element-321">Scratches, dents, fading, or discoloration</li>
                    <li data-id="element-322">
                      Damage caused by misuse, abuse, accidents, negligence, or
                      improper handling
                    </li>
                    <li data-id="element-323">Improper washing, maintenance, or storage</li>
                    <li data-id="element-324">Unauthorized modifications or alterations</li>
                    <li data-id="element-325">
                      Damage caused during shipping by third-party carriers
                    </li>
                    <li data-id="element-326">Products used outside their intended purpose</li>
                    <li data-id="element-327">Loss, theft, or accidental damage</li>
                    <li data-id="element-328">
                      Customer dissatisfaction related to sizing, fit, or
                      personal preference
                    </li>
                    <li data-id="element-329">Products marked as Final Sale or Clearance</li>
                  </ul>
                  <p className="mt-2" data-id="element-330">
                    BLACKOUT UNIT reserves the right to determine whether damage
                    is the result of a manufacturing defect or external causes.
                  </p>
                </div>

                <div data-id="element-331">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-332">
                    WARRANTY CLAIM PROCESS
                  </h3>
                  <p data-id="element-333">
                    To submit a warranty claim, customers must contact BLACKOUT
                    UNIT within the applicable warranty period.
                  </p>
                  <p className="mt-2" data-id="element-334">Claims must include:</p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-335">
                    <li data-id="element-336">Full name</li>
                    <li data-id="element-337">Order number</li>
                    <li data-id="element-338">Description of the issue</li>
                    <li data-id="element-339">Clear photographs or videos showing the defect</li>
                    <li data-id="element-340">Proof of purchase</li>
                  </ul>
                  <p className="mt-2" data-id="element-341">
                    Failure to provide sufficient documentation may result in
                    denial of the claim.
                  </p>
                </div>

                <div data-id="element-342">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-343">
                    CLAIM REVIEW PROCESS
                  </h3>
                  <p data-id="element-344">
                    All warranty claims are subject to inspection and approval
                    by BLACKOUT UNIT.
                  </p>
                  <p className="mt-2" data-id="element-345">BLACKOUT UNIT reserves the right to:</p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-346">
                    <li data-id="element-347">Request additional evidence</li>
                    <li data-id="element-348">Deny claims lacking sufficient proof</li>
                    <li data-id="element-349">Require return of the product for inspection</li>
                    <li data-id="element-350">
                      Determine the appropriate resolution at its sole
                      discretion
                    </li>
                  </ul>
                  <p className="mt-2" data-id="element-351">
                    Submitting a claim does not guarantee approval.
                  </p>
                </div>

                <div data-id="element-352">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-353">
                    SHIPPING COSTS FOR WARRANTY CLAIMS
                  </h3>
                  <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-354">
                    <li data-id="element-355">
                      Customers may be responsible for shipping costs associated
                      with warranty claims unless prohibited by applicable law.
                    </li>
                    <li data-id="element-356">Original shipping charges are non-refundable.</li>
                  </ul>
                </div>

                <div data-id="element-357">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-358">
                    LIMITATION OF LIABILITY
                  </h3>
                  <p data-id="element-359">
                    To the fullest extent permitted by law, BLACKOUT UNIT shall
                    not be liable for:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-360">
                    <li data-id="element-361">Indirect damages</li>
                    <li data-id="element-362">Consequential damages</li>
                    <li data-id="element-363">Incidental damages</li>
                    <li data-id="element-364">Loss of use</li>
                    <li data-id="element-365">Loss of profits</li>
                    <li data-id="element-366">Third-party damages</li>
                  </ul>
                  <p className="mt-2" data-id="element-367">
                    BLACKOUT UNIT’s total liability shall never exceed the
                    original purchase price paid for the product.
                  </p>
                </div>

                <div data-id="element-368">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-369">
                    NO OTHER WARRANTIES
                  </h3>
                  <p data-id="element-370">
                    Except as expressly stated herein, BLACKOUT UNIT makes no
                    additional warranties, express or implied, including but not
                    limited to:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-371">
                    <li data-id="element-372">Merchantability</li>
                    <li data-id="element-373">Fitness for a particular purpose</li>
                    <li data-id="element-374">Non-infringement</li>
                  </ul>
                </div>

                <div data-id="element-375">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-376">
                    CHARGEBACK ABUSE & FRAUD
                  </h3>
                  <p data-id="element-377">
                    Any fraudulent warranty claim, abuse of refund systems, or
                    unauthorized chargeback related to a valid order may result
                    in:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-378">
                    <li data-id="element-379">Permanent account restriction</li>
                    <li data-id="element-380">Refusal of future service</li>
                    <li data-id="element-381">
                      Submission to collections or legal review where applicable
                    </li>
                  </ul>
                </div>

                <div data-id="element-382">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-383">
                    POLICY CHANGES
                  </h3>
                  <p data-id="element-384">
                    BLACKOUT UNIT reserves the right to modify or update this
                    Warranty Policy at any time without prior notice.
                  </p>
                </div>

                <div data-id="element-385">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-386">
                    CONTACT INFORMATION
                  </h3>
                  <p data-id="element-387">
                    BLACKOUT UNIT Customer Support Department:{' '}
                    <a href="mailto:support@blackoutunit.com" className="text-acid-green hover:underline" data-id="element-388">
                      support@blackoutunit.com
                    </a>
                  </p>
                </div>
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>

      {/* Returns Policy Modal */}
      <AnimatePresence data-id="element-389">
        {showReturnsPolicy && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6" data-id="element-390">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setShowReturnsPolicy(false)} className="absolute inset-0 bg-black/80 backdrop-blur-sm" data-id="element-391" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="relative w-full max-w-3xl max-h-[85vh] bg-dark-1 border border-dark-3 shadow-2xl flex flex-col" data-id="element-392">
              {/* Modal Header */}
              <div className="flex items-center justify-between p-6 border-b border-dark-3 bg-base-black" data-id="element-393">
                <h2 className="font-bebas text-3xl text-white tracking-wider" data-id="element-394">
                  RETURNS & EXCHANGES POLICY
                </h2>
                <button onClick={() => setShowReturnsPolicy(false)} className="text-text-dimmed hover:text-acid-green transition-colors" data-id="element-395">
                  <X size={24} data-id="element-396" />
                </button>
              </div>

              {/* Modal Body */}
              <div className="p-6 overflow-y-auto font-inter text-sm text-text-dimmed leading-relaxed space-y-6 custom-scrollbar" data-id="element-397">
                <p data-id="element-398">
                  <strong data-id="element-399">Effective Date:</strong> May 18, 2026
                </p>
                <p data-id="element-400">
                  At BLACKOUT UNIT, all purchases are subject to the terms
                  outlined in this Returns & Exchanges Policy. Due to the nature
                  of our products, limited inventory releases, promotional
                  pricing, discounted offers, and hygiene/safety considerations,
                  all sales are considered final unless otherwise stated below.
                </p>
                <p data-id="element-401">
                  By placing an order with BLACKOUT UNIT, the customer
                  acknowledges and agrees to this policy in full.
                </p>

                <div data-id="element-402">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-403">
                    ALL SALES ARE FINAL
                  </h3>
                  <p data-id="element-404">
                    Due to the nature of our products, including tactical gear,
                    face coverings, accessories, promotional inventory,
                    discounted products, and limited releases, ALL SALES ARE
                    FINAL.
                  </p>
                  <p className="mt-2" data-id="element-405">
                    BLACKOUT UNIT does not guarantee refunds, exchanges, or
                    returns for:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-406">
                    <li data-id="element-407">Buyer’s remorse</li>
                    <li data-id="element-408">Incorrect size selection</li>
                    <li data-id="element-409">Personal preference</li>
                    <li data-id="element-410">Change of mind</li>
                    <li data-id="element-411">Delayed carrier delivery</li>
                    <li data-id="element-412">Refused shipments</li>
                    <li data-id="element-413">Incorrect addresses entered by the customer</li>
                  </ul>
                  <p className="mt-2" data-id="element-414">
                    Products purchased during promotions, discount campaigns,
                    clearance events, coupon offers, or limited releases are
                    considered Final Sale and are non-refundable.
                  </p>
                </div>

                <div data-id="element-415">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-416">
                    RETURN EXCEPTIONS
                  </h3>
                  <p data-id="element-417">A return or replacement may only be considered if:</p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-418">
                    <li data-id="element-419">The wrong item was shipped by BLACKOUT UNIT</li>
                    <li data-id="element-420">
                      The product arrives with a verified manufacturing defect
                    </li>
                    <li data-id="element-421">
                      The item arrives physically damaged due to a verified
                      fulfillment error
                    </li>
                  </ul>
                  <p className="mt-2" data-id="element-422">
                    All claims must be submitted within 48 hours of delivery.
                    Claims submitted after this period may be denied.
                  </p>
                </div>

                <div data-id="element-423">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-424">
                    CLAIM REQUIREMENTS
                  </h3>
                  <p data-id="element-425">
                    To request review of a damaged or incorrect order, the
                    customer must provide:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-426">
                    <li data-id="element-427">Full name</li>
                    <li data-id="element-428">Order number</li>
                    <li data-id="element-429">Clear photographs of the item</li>
                    <li data-id="element-430">Clear photographs of the packaging</li>
                    <li data-id="element-431">Description of the issue</li>
                  </ul>
                  <p className="mt-2" data-id="element-432">
                    BLACKOUT UNIT reserves the right to deny any request lacking
                    sufficient evidence.
                  </p>
                </div>

                <div data-id="element-433">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-434">
                    RETURN AUTHORIZATION REQUIRED
                  </h3>
                  <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-435">
                    <li data-id="element-436">
                      No return will be accepted without prior written
                      authorization from BLACKOUT UNIT.
                    </li>
                    <li data-id="element-437">
                      Unauthorized returns may be refused or discarded without
                      refund.
                    </li>
                  </ul>
                </div>

                <div data-id="element-438">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-439">
                    RETURN SHIPPING COSTS
                  </h3>
                  <p data-id="element-440">If a return is exceptionally approved by BLACKOUT UNIT:</p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-441">
                    <li data-id="element-442">
                      The customer is solely responsible for purchasing the
                      return shipping label
                    </li>
                    <li data-id="element-443">
                      The customer is responsible for all return shipping costs
                    </li>
                    <li data-id="element-444">
                      Original shipping costs are non-refundable under all
                      circumstances
                    </li>
                  </ul>
                  <p className="mt-2" data-id="element-445">
                    Shipping fees paid at checkout are considered completed
                    carrier service charges and will not be refunded.
                  </p>
                </div>

                <div data-id="element-446">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-447">
                    REFUND CONDITIONS
                  </h3>
                  <p data-id="element-448">
                    If BLACKOUT UNIT approves a refund at its sole discretion:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-449">
                    <li data-id="element-450">
                      Refunds may be issued as store credit, replacement
                      product, or original payment refund
                    </li>
                    <li data-id="element-451">
                      Refunds will apply only to the product purchase price
                    </li>
                    <li data-id="element-452">Original shipping costs will not be refunded</li>
                    <li data-id="element-453">Return shipping costs will not be reimbursed</li>
                  </ul>
                  <p className="mt-2" data-id="element-454">
                    BLACKOUT UNIT reserves the right to issue partial refunds
                    where appropriate.
                  </p>
                </div>

                <div data-id="element-455">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-456">
                    NON-RETURNABLE ITEMS
                  </h3>
                  <p data-id="element-457">
                    The following items are strictly non-returnable and
                    non-refundable:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-458">
                    <li data-id="element-459">Tactical masks</li>
                    <li data-id="element-460">Face coverings</li>
                    <li data-id="element-461">Worn merchandise</li>
                    <li data-id="element-462">Opened products</li>
                    <li data-id="element-463">Clearance items</li>
                    <li data-id="element-464">Promotional items</li>
                    <li data-id="element-465">Discounted items</li>
                    <li data-id="element-466">Limited-release products</li>
                    <li data-id="element-467">Custom or personalized items</li>
                    <li data-id="element-468">Gift cards</li>
                    <li data-id="element-469">Hygiene-sensitive products</li>
                  </ul>
                  <p className="mt-2" data-id="element-470">
                    For health, hygiene, and safety reasons, face-related
                    products and tactical wear cannot be returned once
                    delivered.
                  </p>
                </div>

                <div data-id="element-471">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-472">
                    CHARGEBACKS & PAYMENT DISPUTES
                  </h3>
                  <p data-id="element-473">
                    Customers agree not to initiate fraudulent or abusive
                    chargebacks for valid purchases. By completing a purchase
                    with BLACKOUT UNIT, the customer acknowledges that:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-474">
                    <li data-id="element-475">
                      Product descriptions, policies, and checkout terms were
                      reviewed prior to purchase
                    </li>
                    <li data-id="element-476">
                      Charges submitted for completed orders are authorized
                    </li>
                    <li data-id="element-477">
                      Shipping and processing timelines are disclosed before
                      checkout
                    </li>
                  </ul>
                  <p className="mt-2" data-id="element-478">
                    Fraudulent disputes, abusive chargebacks, or attempts to
                    retain merchandise while reversing payment may result in:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-479">
                    <li data-id="element-480">Permanent ban from future purchases</li>
                    <li data-id="element-481">Submission of evidence to the payment processor</li>
                    <li data-id="element-482">Collections activity where legally permitted</li>
                    <li data-id="element-483">Civil recovery actions where applicable</li>
                  </ul>
                  <p className="mt-2" data-id="element-484">
                    BLACKOUT UNIT reserves all rights to dispute invalid
                    chargebacks with supporting documentation, including
                    tracking confirmation, order records, customer
                    communications, and policy acceptance logs.
                  </p>
                </div>

                <div data-id="element-485">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-486">
                    LOST, STOLEN, OR DELIVERED PACKAGES
                  </h3>
                  <p data-id="element-487">BLACKOUT UNIT is not responsible for:</p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-488">
                    <li data-id="element-489">Lost packages</li>
                    <li data-id="element-490">Stolen packages</li>
                    <li data-id="element-491">Carrier delays</li>
                    <li data-id="element-492">Packages marked as “Delivered”</li>
                    <li data-id="element-493">Incorrect addresses entered by the customer</li>
                  </ul>
                  <p className="mt-2" data-id="element-494">
                    Once the carrier marks a package as delivered,
                    responsibility transfers to the customer.
                  </p>
                </div>

                <div data-id="element-495">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-496">
                    LIMITATION OF LIABILITY
                  </h3>
                  <p data-id="element-497">
                    To the fullest extent permitted by law, BLACKOUT UNIT shall
                    not be liable for:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-498">
                    <li data-id="element-499">Indirect damages</li>
                    <li data-id="element-500">Consequential damages</li>
                    <li data-id="element-501">Loss of use</li>
                    <li data-id="element-502">Carrier delays</li>
                    <li data-id="element-503">Customer misuse</li>
                    <li data-id="element-504">Third-party handling issues</li>
                  </ul>
                  <p className="mt-2" data-id="element-505">
                    BLACKOUT UNIT’s maximum liability shall never exceed the
                    original purchase price of the product ordered.
                  </p>
                </div>

                <div data-id="element-506">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-507">
                    POLICY MODIFICATIONS
                  </h3>
                  <p data-id="element-508">
                    BLACKOUT UNIT reserves the right to modify, update, or
                    revise this policy at any time without prior notice.
                  </p>
                </div>

                <div data-id="element-509">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-510">
                    CONTACT INFORMATION
                  </h3>
                  <p data-id="element-511">
                    BLACKOUT UNIT Customer Support Department:{' '}
                    <a href="mailto:support@blackoutunit.com" className="text-acid-green hover:underline" data-id="element-512">
                      support@blackoutunit.com
                    </a>
                  </p>
                </div>
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>

      {/* Contact Us Modal */}
      <AnimatePresence data-id="element-513">
        {showContactPolicy && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6" data-id="element-514">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setShowContactPolicy(false)} className="absolute inset-0 bg-black/80 backdrop-blur-sm" data-id="element-515" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="relative w-full max-w-3xl max-h-[85vh] bg-dark-1 border border-dark-3 shadow-2xl flex flex-col" data-id="element-516">
              {/* Modal Header */}
              <div className="flex items-center justify-between p-6 border-b border-dark-3 bg-base-black" data-id="element-517">
                <h2 className="font-bebas text-3xl text-white tracking-wider" data-id="element-518">
                  CONTACT US
                </h2>
                <button onClick={() => setShowContactPolicy(false)} className="text-text-dimmed hover:text-acid-green transition-colors" data-id="element-519">
                  <X size={24} data-id="element-520" />
                </button>
              </div>

              {/* Modal Body */}
              <div className="p-6 overflow-y-auto font-inter text-sm text-text-dimmed leading-relaxed space-y-6 custom-scrollbar" data-id="element-521">
                <p data-id="element-522">
                  At BLACKOUT UNIT, we are committed to providing fast and
                  reliable customer support. If you have any questions regarding
                  your order, shipping, products, or general inquiries, please
                  contact our support team using the information below.
                </p>

                <div data-id="element-523">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-524">
                    CUSTOMER SUPPORT
                  </h3>
                  <p data-id="element-525">BLACKOUT UNIT Customer Support Department</p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-526">
                    <li data-id="element-527">
                      <strong data-id="element-528">Email:</strong>{' '}
                      <a href="mailto:support@blackoutunit.com" className="text-acid-green hover:underline" data-id="element-529">
                        support@blackoutunit.com
                      </a>
                    </li>
                    <li data-id="element-530">
                      <strong data-id="element-531">Business Hours:</strong> Monday – Friday 9:00 AM –
                      5:00 PM EST
                    </li>
                  </ul>
                </div>

                <div data-id="element-532">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-533">
                    RESPONSE TIMES
                  </h3>
                  <p data-id="element-534">
                    Our support team typically responds within 24–48 business
                    hours.
                  </p>
                  <p className="mt-2" data-id="element-535">Please note:</p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-536">
                    <li data-id="element-537">
                      Response times may be longer during holidays, weekends,
                      product launches, promotional events, or periods of high
                      order volume.
                    </li>
                    <li data-id="element-538">
                      Sending multiple emails regarding the same issue may delay
                      response times.
                    </li>
                  </ul>
                </div>

                <div data-id="element-539">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-540">
                    ORDER SUPPORT
                  </h3>
                  <p data-id="element-541">For assistance with an existing order, please include:</p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-542">
                    <li data-id="element-543">Full name</li>
                    <li data-id="element-544">Order number</li>
                    <li data-id="element-545">Email address used at checkout</li>
                    <li data-id="element-546">Detailed description of your request</li>
                  </ul>
                  <p className="mt-2" data-id="element-547">
                    Providing complete information helps us resolve your request
                    more efficiently.
                  </p>
                </div>

                <div data-id="element-548">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-549">
                    SHIPPING & DELIVERY QUESTIONS
                  </h3>
                  <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-550">
                    <li data-id="element-551">
                      Before contacting support regarding shipping updates,
                      please verify your tracking information first.
                    </li>
                    <li data-id="element-552">
                      Tracking numbers are automatically sent once orders have
                      shipped.
                    </li>
                    <li data-id="element-553">
                      BLACKOUT UNIT is not responsible for carrier delays after
                      packages have been transferred to USPS or the selected
                      shipping carrier.
                    </li>
                  </ul>
                </div>

                <div data-id="element-554">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-555">
                    RETURNS & CLAIMS
                  </h3>
                  <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-556">
                    <li data-id="element-557">
                      For return requests, damaged item claims, or order issues,
                      customers must contact us within the timeframes outlined
                      in our policies.
                    </li>
                    <li data-id="element-558">
                      Please include supporting photos and documentation when
                      applicable.
                    </li>
                  </ul>
                </div>

                <div data-id="element-559">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-560">
                    BUSINESS & COLLABORATION INQUIRIES
                  </h3>
                  <p data-id="element-561">
                    For partnerships, collaborations, wholesale opportunities,
                    or media inquiries, please contact:{' '}
                    <a href="mailto:business@blackoutunit.com" className="text-acid-green hover:underline" data-id="element-562">
                      business@blackoutunit.com
                    </a>
                  </p>
                </div>

                <div data-id="element-563">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-564">
                    IMPORTANT NOTICE
                  </h3>
                  <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-565">
                    <li data-id="element-566">
                      BLACKOUT UNIT reserves the right to refuse service,
                      abusive communications, fraudulent claims, or bad-faith
                      disputes.
                    </li>
                    <li data-id="element-567">
                      Threatening, abusive, defamatory, or fraudulent conduct
                      toward our staff or business may result in termination of
                      communication and refusal of future service.
                    </li>
                  </ul>
                </div>
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>

      {/* Privacy Policy Modal */}
      <AnimatePresence data-id="element-568">
        {showPrivacyPolicy && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6" data-id="element-569">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setShowPrivacyPolicy(false)} className="absolute inset-0 bg-black/80 backdrop-blur-sm" data-id="element-570" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="relative w-full max-w-3xl max-h-[85vh] bg-dark-1 border border-dark-3 shadow-2xl flex flex-col" data-id="element-571">
              {/* Modal Header */}
              <div className="flex items-center justify-between p-6 border-b border-dark-3 bg-base-black" data-id="element-572">
                <h2 className="font-bebas text-3xl text-white tracking-wider" data-id="element-573">
                  PRIVACY POLICY
                </h2>
                <button onClick={() => setShowPrivacyPolicy(false)} className="text-text-dimmed hover:text-acid-green transition-colors" data-id="element-574">
                  <X size={24} data-id="element-575" />
                </button>
              </div>

              {/* Modal Body */}
              <div className="p-6 overflow-y-auto font-inter text-sm text-text-dimmed leading-relaxed space-y-6 custom-scrollbar" data-id="element-576">
                <p data-id="element-577">
                  <strong data-id="element-578">Effective Date:</strong> May 18, 2026
                </p>
                <p data-id="element-579">
                  BLACKOUT UNIT (“BLACKOUT UNIT,” “we,” “our,” or “us”) respects
                  your privacy and is committed to protecting your personal
                  information. This Privacy Policy explains how we collect, use,
                  store, and protect your information when you visit or make a
                  purchase from our website.
                </p>
                <p data-id="element-580">
                  By accessing or using our website, you acknowledge and agree
                  to the practices described in this Privacy Policy.
                </p>

                <div data-id="element-581">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-582">
                    INFORMATION WE COLLECT
                  </h3>
                  <p data-id="element-583">
                    When you visit or interact with our website, we may collect
                    certain information, including but not limited to:
                  </p>
                  <h4 className="font-bold text-white mt-4 mb-2" data-id="element-584">
                    Personal Information
                  </h4>
                  <ul className="list-disc pl-5 space-y-1" data-id="element-585">
                    <li data-id="element-586">Full name</li>
                    <li data-id="element-587">Billing address</li>
                    <li data-id="element-588">Shipping address</li>
                    <li data-id="element-589">Email address</li>
                    <li data-id="element-590">Phone number</li>
                    <li data-id="element-591">Payment information</li>
                    <li data-id="element-592">Order history</li>
                  </ul>
                  <h4 className="font-bold text-white mt-4 mb-2" data-id="element-593">
                    Technical & Device Information
                  </h4>
                  <ul className="list-disc pl-5 space-y-1" data-id="element-594">
                    <li data-id="element-595">IP address</li>
                    <li data-id="element-596">Browser type</li>
                    <li data-id="element-597">Device type</li>
                    <li data-id="element-598">Operating system</li>
                    <li data-id="element-599">Referral URLs</li>
                    <li data-id="element-600">Website activity and interaction data</li>
                  </ul>
                  <h4 className="font-bold text-white mt-4 mb-2" data-id="element-601">
                    Transaction Information
                  </h4>
                  <ul className="list-disc pl-5 space-y-1" data-id="element-602">
                    <li data-id="element-603">Products purchased</li>
                    <li data-id="element-604">Order value</li>
                    <li data-id="element-605">Payment method</li>
                    <li data-id="element-606">Shipping details</li>
                  </ul>
                </div>

                <div data-id="element-607">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-608">
                    HOW WE USE YOUR INFORMATION
                  </h3>
                  <p data-id="element-609">We may use collected information to:</p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-610">
                    <li data-id="element-611">Process and fulfill orders</li>
                    <li data-id="element-612">Provide customer support</li>
                    <li data-id="element-613">Send order confirmations and tracking updates</li>
                    <li data-id="element-614">Prevent fraud and unauthorized transactions</li>
                    <li data-id="element-615">
                      Improve website functionality and customer experience
                    </li>
                    <li data-id="element-616">Conduct analytics and operational improvements</li>
                    <li data-id="element-617">Enforce our Terms & Policies</li>
                    <li data-id="element-618">
                      Communicate promotional offers or marketing updates (where
                      permitted)
                    </li>
                  </ul>
                </div>

                <div data-id="element-619">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-620">
                    PAYMENT SECURITY
                  </h3>
                  <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-621">
                    <li data-id="element-622">
                      BLACKOUT UNIT does not directly store complete payment
                      card information.
                    </li>
                    <li data-id="element-623">
                      Payments are securely processed through third-party
                      payment processors and gateways compliant with industry
                      security standards.
                    </li>
                    <li data-id="element-624">
                      However, no method of transmission or storage is 100%
                      secure, and BLACKOUT UNIT cannot guarantee absolute
                      security.
                    </li>
                  </ul>
                </div>

                <div data-id="element-625">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-626">
                    COOKIES & TRACKING TECHNOLOGIES
                  </h3>
                  <p data-id="element-627">
                    Our website may use cookies, pixels, analytics tools, and
                    similar technologies to:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-628">
                    <li data-id="element-629">Improve site performance</li>
                    <li data-id="element-630">Personalize user experience</li>
                    <li data-id="element-631">Analyze website traffic</li>
                    <li data-id="element-632">Support advertising and remarketing campaigns</li>
                  </ul>
                  <p className="mt-2" data-id="element-633">
                    Users may disable cookies through their browser settings;
                    however, portions of the website may not function properly
                    as a result.
                  </p>
                </div>

                <div data-id="element-634">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-635">
                    THIRD-PARTY SERVICES
                  </h3>
                  <p data-id="element-636">
                    We may share information with trusted third-party service
                    providers involved in:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-637">
                    <li data-id="element-638">Payment processing</li>
                    <li data-id="element-639">Shipping and logistics</li>
                    <li data-id="element-640">Website hosting</li>
                    <li data-id="element-641">Fraud prevention</li>
                    <li data-id="element-642">Marketing and analytics</li>
                  </ul>
                  <p className="mt-2" data-id="element-643">
                    These third parties receive only the information reasonably
                    necessary to perform their services. BLACKOUT UNIT is not
                    responsible for the independent privacy practices of
                    third-party websites or services.
                  </p>
                </div>

                <div data-id="element-644">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-645">
                    FRAUD PREVENTION & LEGAL COMPLIANCE
                  </h3>
                  <p data-id="element-646">
                    We reserve the right to disclose information when necessary
                    to:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-647">
                    <li data-id="element-648">Comply with legal obligations</li>
                    <li data-id="element-649">Respond to lawful requests</li>
                    <li data-id="element-650">Protect BLACKOUT UNIT’s rights or property</li>
                    <li data-id="element-651">
                      Prevent fraud, abuse, chargebacks, or unauthorized
                      transactions
                    </li>
                    <li data-id="element-652">Enforce our agreements and policies</li>
                  </ul>
                </div>

                <div data-id="element-653">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-654">
                    DATA RETENTION
                  </h3>
                  <p data-id="element-655">
                    We retain customer information only as long as reasonably
                    necessary for:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-656">
                    <li data-id="element-657">Business operations</li>
                    <li data-id="element-658">Legal compliance</li>
                    <li data-id="element-659">Tax obligations</li>
                    <li data-id="element-660">Fraud prevention</li>
                    <li data-id="element-661">Dispute resolution</li>
                    <li data-id="element-662">Enforcement of agreements</li>
                  </ul>
                  <p className="mt-2" data-id="element-663">
                    BLACKOUT UNIT reserves the right to maintain transaction
                    records and related communications for legal and operational
                    purposes.
                  </p>
                </div>

                <div data-id="element-664">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-665">
                    MARKETING COMMUNICATIONS
                  </h3>
                  <p data-id="element-666">
                    By providing your email address or phone number, you may
                    receive:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-667">
                    <li data-id="element-668">Order notifications</li>
                    <li data-id="element-669">Marketing emails</li>
                    <li data-id="element-670">Promotional messages</li>
                    <li data-id="element-671">Product announcements</li>
                  </ul>
                  <p className="mt-2" data-id="element-672">
                    You may opt out of marketing communications at any time by
                    using the unsubscribe link or contacting support.
                  </p>
                </div>

                <div data-id="element-673">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-674">
                    CHILDREN’S PRIVACY
                  </h3>
                  <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-675">
                    <li data-id="element-676">
                      BLACKOUT UNIT does not knowingly collect personal
                      information from individuals under the age of 13.
                    </li>
                    <li data-id="element-677">
                      If we become aware that information from a minor has been
                      collected, we reserve the right to delete such
                      information.
                    </li>
                  </ul>
                </div>

                <div data-id="element-678">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-679">
                    INTERNATIONAL USERS
                  </h3>
                  <p data-id="element-680">
                    If you access our website from outside the United States,
                    you acknowledge that your information may be transferred to
                    and processed within the United States.
                  </p>
                </div>

                <div data-id="element-681">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-682">
                    NO GUARANTEE OF UNINTERRUPTED SERVICE
                  </h3>
                  <p data-id="element-683">
                    While we take reasonable measures to protect our systems and
                    customer data, BLACKOUT UNIT does not guarantee that the
                    website or servers will always be secure, uninterrupted, or
                    free from unauthorized access.
                  </p>
                </div>

                <div data-id="element-684">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-685">
                    LIMITATION OF LIABILITY
                  </h3>
                  <p data-id="element-686">
                    To the fullest extent permitted by law, BLACKOUT UNIT shall
                    not be liable for:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-687">
                    <li data-id="element-688">Unauthorized third-party access</li>
                    <li data-id="element-689">Cyberattacks</li>
                    <li data-id="element-690">Data breaches beyond reasonable control</li>
                    <li data-id="element-691">Service interruptions</li>
                    <li data-id="element-692">
                      Indirect or consequential damages arising from website use
                    </li>
                  </ul>
                </div>

                <div data-id="element-693">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-694">
                    POLICY CHANGES
                  </h3>
                  <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-695">
                    <li data-id="element-696">
                      BLACKOUT UNIT reserves the right to modify or update this
                      Privacy Policy at any time without prior notice.
                    </li>
                    <li data-id="element-697">
                      Changes become effective immediately upon posting to the
                      website.
                    </li>
                  </ul>
                </div>

                <div data-id="element-698">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-699">
                    CONTACT INFORMATION
                  </h3>
                  <p data-id="element-700">
                    BLACKOUT UNIT Privacy & Support Department:{' '}
                    <a href="mailto:support@blackoutunit.com" className="text-acid-green hover:underline" data-id="element-701">
                      support@blackoutunit.com
                    </a>
                  </p>
                </div>
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>

      {/* Terms of Service Modal */}
      <AnimatePresence data-id="element-702">
        {showTermsPolicy && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6" data-id="element-703">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setShowTermsPolicy(false)} className="absolute inset-0 bg-black/80 backdrop-blur-sm" data-id="element-704" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="relative w-full max-w-3xl max-h-[85vh] bg-dark-1 border border-dark-3 shadow-2xl flex flex-col" data-id="element-705">
              {/* Modal Header */}
              <div className="flex items-center justify-between p-6 border-b border-dark-3 bg-base-black" data-id="element-706">
                <h2 className="font-bebas text-3xl text-white tracking-wider" data-id="element-707">
                  TERMS OF SERVICE
                </h2>
                <button onClick={() => setShowTermsPolicy(false)} className="text-text-dimmed hover:text-acid-green transition-colors" data-id="element-708">
                  <X size={24} data-id="element-709" />
                </button>
              </div>

              {/* Modal Body */}
              <div className="p-6 overflow-y-auto font-inter text-sm text-text-dimmed leading-relaxed space-y-6 custom-scrollbar" data-id="element-710">
                <p data-id="element-711">
                  <strong data-id="element-712">Effective Date:</strong> May 18, 2026
                </p>
                <p data-id="element-713">
                  Welcome to BLACKOUT UNIT. These Terms of Service (“Terms”)
                  govern your access to and use of the BLACKOUT UNIT website,
                  products, services, and related content.
                </p>
                <p data-id="element-714">
                  By accessing this website or placing an order with BLACKOUT
                  UNIT, you acknowledge that you have read, understood, and
                  agreed to be legally bound by these Terms of Service.
                </p>
                <p data-id="element-715">
                  If you do not agree with these Terms, you must not use this
                  website.
                </p>

                <div data-id="element-716">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-717">
                    1. GENERAL CONDITIONS
                  </h3>
                  <p data-id="element-718">
                    BLACKOUT UNIT reserves the right to refuse service to
                    anyone, at any time, for any reason, including but not
                    limited to:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-719">
                    <li data-id="element-720">Suspected fraud</li>
                    <li data-id="element-721">Abuse of policies</li>
                    <li data-id="element-722">Chargeback abuse</li>
                    <li data-id="element-723">Harassment or threatening conduct</li>
                    <li data-id="element-724">Unauthorized resale activity</li>
                    <li data-id="element-725">Violations of these Terms</li>
                  </ul>
                  <p className="mt-2" data-id="element-726">
                    We reserve the right to limit, cancel, or refuse orders at
                    our sole discretion.
                  </p>
                </div>

                <div data-id="element-727">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-728">
                    2. ELIGIBILITY
                  </h3>
                  <p data-id="element-729">By using this website, you represent that:</p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-730">
                    <li data-id="element-731">
                      You are at least 18 years old or have permission from a
                      legal guardian
                    </li>
                    <li data-id="element-732">All information provided is accurate and complete</li>
                    <li data-id="element-733">
                      You are legally authorized to use the selected payment
                      method
                    </li>
                  </ul>
                </div>

                <div data-id="element-734">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-735">
                    3. PRODUCTS & AVAILABILITY
                  </h3>
                  <p data-id="element-736">BLACKOUT UNIT reserves the right to:</p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-737">
                    <li data-id="element-738">Modify products</li>
                    <li data-id="element-739">Change pricing</li>
                    <li data-id="element-740">Discontinue items</li>
                    <li data-id="element-741">Limit quantities</li>
                    <li data-id="element-742">Correct pricing or listing errors</li>
                  </ul>
                  <p className="mt-2" data-id="element-743">without prior notice.</p>
                  <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-744">
                    <li data-id="element-745">
                      All product availability is subject to inventory and
                      operational limitations.
                    </li>
                    <li data-id="element-746">
                      We do not guarantee that product descriptions, images,
                      colors, or specifications will appear exactly the same
                      across all devices or displays.
                    </li>
                  </ul>
                </div>

                <div data-id="element-747">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-748">
                    4. ORDER ACCEPTANCE
                  </h3>
                  <p data-id="element-749">
                    An order confirmation does not constitute final acceptance
                    of an order.
                  </p>
                  <p className="mt-2" data-id="element-750">BLACKOUT UNIT reserves the right to:</p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-751">
                    <li data-id="element-752">Refuse or cancel orders</li>
                    <li data-id="element-753">Limit quantities purchased</li>
                    <li data-id="element-754">Reject suspicious transactions</li>
                    <li data-id="element-755">Request additional verification</li>
                  </ul>
                  <p className="mt-2" data-id="element-756">
                    Orders may be canceled for reasons including:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-757">
                    <li data-id="element-758">Fraud prevention</li>
                    <li data-id="element-759">Payment authorization failure</li>
                    <li data-id="element-760">Inventory shortages</li>
                    <li data-id="element-761">Pricing inaccuracies</li>
                    <li data-id="element-762">Operational concerns</li>
                  </ul>
                </div>

                <div data-id="element-763">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-764">
                    5. PRICING & PAYMENT
                  </h3>
                  <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-765">
                    <li data-id="element-766">All prices displayed are in U.S. Dollars (USD).</li>
                    <li data-id="element-767">
                      Customers agree to pay all charges associated with their
                      order, including: Product costs, Shipping fees, Taxes, and
                      Applicable processing fees.
                    </li>
                    <li data-id="element-768">
                      By submitting payment, the customer authorizes BLACKOUT
                      UNIT and its payment processors to charge the selected
                      payment method.
                    </li>
                    <li data-id="element-769">
                      Failure to successfully process payment may result in
                      order cancellation.
                    </li>
                  </ul>
                </div>

                <div data-id="element-770">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-771">
                    6. SHIPPING & DELIVERY
                  </h3>
                  <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-772">
                    <li data-id="element-773">
                      Shipping timelines provided are estimates only and are not
                      guaranteed.
                    </li>
                    <li data-id="element-774">
                      BLACKOUT UNIT is not responsible for delays caused by:
                      USPS or shipping carriers, Weather, Customs, Operational
                      disruptions, or Incorrect customer information.
                    </li>
                    <li data-id="element-775">
                      Risk of loss transfers to the customer once the package
                      has been transferred to the shipping carrier.
                    </li>
                    <li data-id="element-776">
                      Customers are responsible for providing accurate shipping
                      information.
                    </li>
                  </ul>
                </div>

                <div data-id="element-777">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-778">
                    7. RETURNS, EXCHANGES & FINAL SALE ITEMS
                  </h3>
                  <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-779">
                    <li data-id="element-780">
                      Due to the nature of our products, promotional pricing,
                      limited releases, tactical gear, and hygiene-sensitive
                      merchandise, many products sold by BLACKOUT UNIT are
                      considered Final Sale.
                    </li>
                    <li data-id="element-781">
                      Customers agree to review our Returns & Exchanges Policy
                      prior to purchase.
                    </li>
                    <li data-id="element-782">Original shipping costs are non-refundable.</li>
                    <li data-id="element-783">
                      If a return is exceptionally approved, the customer is
                      responsible for all return shipping costs and return
                      labels.
                    </li>
                  </ul>
                </div>

                <div data-id="element-784">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-785">
                    8. WARRANTY DISCLAIMER
                  </h3>
                  <p data-id="element-786">
                    Except where expressly stated, all products are sold “AS IS”
                    and “AS AVAILABLE.”
                  </p>
                  <p className="mt-2" data-id="element-787">
                    BLACKOUT UNIT disclaims all warranties, express or implied,
                    including but not limited to:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-788">
                    <li data-id="element-789">Merchantability</li>
                    <li data-id="element-790">Fitness for a particular purpose</li>
                    <li data-id="element-791">Non-infringement</li>
                  </ul>
                  <p className="mt-2" data-id="element-792">
                    We do not guarantee uninterrupted, error-free, or
                    defect-free operation of the website or products.
                  </p>
                </div>

                <div data-id="element-793">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-794">
                    9. USER CONDUCT
                  </h3>
                  <p data-id="element-795">Customers and users agree not to:</p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-796">
                    <li data-id="element-797">Use the website unlawfully</li>
                    <li data-id="element-798">Commit fraud</li>
                    <li data-id="element-799">Abuse refund or chargeback systems</li>
                    <li data-id="element-800">Interfere with website operations</li>
                    <li data-id="element-801">Upload malicious code</li>
                    <li data-id="element-802">Impersonate others</li>
                    <li data-id="element-803">Harass or threaten BLACKOUT UNIT staff</li>
                  </ul>
                  <p className="mt-2" data-id="element-804">
                    Violation of these Terms may result in account termination,
                    order cancellation, legal action, or refusal of future
                    service.
                  </p>
                </div>

                <div data-id="element-805">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-806">
                    10. INTELLECTUAL PROPERTY
                  </h3>
                  <p data-id="element-807">
                    All website content, including but not limited to: Logos,
                    Branding, Product designs, Images, Graphics, Text, Videos,
                    and Marketing materials is the exclusive property of
                    BLACKOUT UNIT and may not be copied, reproduced, modified,
                    or distributed without written permission.
                  </p>
                </div>

                <div data-id="element-808">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-809">
                    11. LIMITATION OF LIABILITY
                  </h3>
                  <p data-id="element-810">
                    To the fullest extent permitted by law, BLACKOUT UNIT shall
                    not be liable for:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-811">
                    <li data-id="element-812">Indirect damages</li>
                    <li data-id="element-813">Consequential damages</li>
                    <li data-id="element-814">Lost profits</li>
                    <li data-id="element-815">Delayed shipments</li>
                    <li data-id="element-816">Carrier issues</li>
                    <li data-id="element-817">Data loss</li>
                    <li data-id="element-818">Unauthorized access</li>
                    <li data-id="element-819">Product misuse</li>
                  </ul>
                  <p className="mt-2" data-id="element-820">
                    BLACKOUT UNIT’s total liability shall never exceed the
                    amount paid for the product purchased.
                  </p>
                </div>

                <div data-id="element-821">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-822">
                    12. CHARGEBACKS & PAYMENT DISPUTES
                  </h3>
                  <p data-id="element-823">
                    Customers agree not to initiate false, abusive, or
                    fraudulent chargebacks.
                  </p>
                  <p className="mt-2" data-id="element-824">
                    By completing a purchase, the customer acknowledges that:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-825">
                    <li data-id="element-826">Product descriptions were reviewed</li>
                    <li data-id="element-827">Policies were accepted</li>
                    <li data-id="element-828">Shipping and processing timelines were disclosed</li>
                    <li data-id="element-829">The transaction was authorized</li>
                  </ul>
                  <p className="mt-2" data-id="element-830">
                    BLACKOUT UNIT reserves the right to dispute invalid
                    chargebacks using: Tracking information, Order records, IP
                    logs, Customer communications, Proof of delivery, and Policy
                    acceptance records.
                  </p>
                  <p className="mt-2" data-id="element-831">Fraudulent disputes may result in:</p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-832">
                    <li data-id="element-833">Permanent refusal of service</li>
                    <li data-id="element-834">Collections activity</li>
                    <li data-id="element-835">Legal action where permitted</li>
                  </ul>
                </div>

                <div data-id="element-836">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-837">
                    13. FORCE MAJEURE
                  </h3>
                  <p data-id="element-838">
                    BLACKOUT UNIT shall not be liable for delays or failure to
                    perform caused by circumstances beyond reasonable control,
                    including but not limited to: Natural disasters, Carrier
                    disruptions, Cyberattacks, Government actions, Supply chain
                    interruptions, Labor shortages, or Power outages.
                  </p>
                </div>

                <div data-id="element-839">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-840">
                    14. GOVERNING LAW
                  </h3>
                  <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-841">
                    <li data-id="element-842">
                      These Terms shall be governed and interpreted under the
                      laws of the State of Florida, United States, without
                      regard to conflict of law principles.
                    </li>
                    <li data-id="element-843">
                      Any dispute arising from these Terms shall be resolved
                      exclusively in the appropriate courts located within the
                      State of Florida.
                    </li>
                  </ul>
                </div>

                <div data-id="element-844">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-845">
                    15. SEVERABILITY
                  </h3>
                  <p data-id="element-846">
                    If any provision of these Terms is found unenforceable or
                    invalid, the remaining provisions shall remain in full force
                    and effect.
                  </p>
                </div>

                <div data-id="element-847">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-848">
                    16. MODIFICATIONS TO TERMS
                  </h3>
                  <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-849">
                    <li data-id="element-850">
                      BLACKOUT UNIT reserves the right to modify these Terms of
                      Service at any time without prior notice.
                    </li>
                    <li data-id="element-851">
                      Continued use of the website following changes constitutes
                      acceptance of the revised Terms.
                    </li>
                  </ul>
                </div>

                <div data-id="element-852">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-853">
                    17. CONTACT INFORMATION
                  </h3>
                  <p data-id="element-854">
                    BLACKOUT UNIT Support Department:{' '}
                    <a href="mailto:support@blackoutunit.com" className="text-acid-green hover:underline" data-id="element-855">
                      support@blackoutunit.com
                    </a>
                  </p>
                </div>
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>

      {/* Top Section */}
      <div className="container mx-auto px-6 md:px-12 py-[80px] pb-[60px]" data-id="element-856">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12" data-id="element-857">
          {/* Col 1 - Brand */}
          <div data-id="element-858">
            <div className="flex items-center gap-3 mb-3" data-id="element-859">
              <img src="https://cdn.magicpatterns.com/uploads/gtew43sgjbWAUi8V7My12k/hf_20260505_154603_f5f185ee-8480-4693-8c47-91f27540bf0d.png" alt="Blackout Unit Logo" className="w-14 h-14 object-contain" data-id="element-860" />
              <div data-id="element-861">
                <div className="font-bebas text-2xl tracking-wider text-white leading-none" data-id="element-862">
                  BLACKOUT <span className="text-acid-green" data-id="element-863">UNIT™</span>
                </div>
                <div className="font-barlow font-bold text-[9px] text-acid-green tracking-[3px] uppercase mt-1" data-id="element-864">
                  EST. 2019
                </div>
              </div>
            </div>
            <div className="font-barlow text-sm text-white tracking-widest uppercase mb-6" data-id="element-865">
              Built by Operators. For Operators.
            </div>
            <p className="font-inter text-xs text-text-dimmed leading-relaxed mb-6 pr-4" data-id="element-866">
              "We spent two years building the mask the industry refused to
              make. This is it. No compromises. No cheap materials. No apologies
              for the standard we hold."
            </p>
            <div className="flex gap-3" data-id="element-867">
              {['IG', 'TT', 'YT', 'FB', 'X'].map(social => <a key={social} href="#" className="w-8 h-8 bg-dark-1 border border-dark-3 flex items-center justify-center text-xs font-barlow text-text-dimmed hover:text-acid-green hover:border-acid-green transition-colors" data-id="element-868">
                  {social}
                </a>)}
            </div>
          </div>

          {/* Col 2 - Arsenal */}
          <div data-id="element-869">
            <h4 className="font-bebas text-xl text-white mb-6" data-id="element-870">ARSENAL</h4>
            <ul className="space-y-3 font-inter text-sm text-text-dimmed" data-id="element-871">
              <li data-id="element-872">
                <button onClick={() => document.getElementById('the-mask')?.scrollIntoView({
                behavior: 'smooth'
              })} className="hover:text-acid-green transition-colors text-left" data-id="element-873">
                  Ultimate Mask
                </button>
              </li>
              <li data-id="element-874">
                <button onClick={() => document.getElementById('the-mask')?.scrollIntoView({
                behavior: 'smooth'
              })} className="hover:text-acid-green transition-colors text-left" data-id="element-875">
                  Individual Lens Packs
                </button>
              </li>
              <li data-id="element-876">
                <button onClick={() => document.getElementById('the-mask')?.scrollIntoView({
                behavior: 'smooth'
              })} className="hover:text-acid-green transition-colors text-left" data-id="element-877">
                  The Ghost Bundle
                </button>
              </li>
              <li data-id="element-878">
                <button onClick={() => document.getElementById('the-mask')?.scrollIntoView({
                behavior: 'smooth'
              })} className="hover:text-acid-green transition-colors text-left" data-id="element-879">
                  The Operator Bundle
                </button>
              </li>
              <li data-id="element-880">
                <button onClick={() => document.getElementById('the-mask')?.scrollIntoView({
                behavior: 'smooth'
              })} className="hover:text-acid-green transition-colors text-left" data-id="element-881">
                  The Squad Bundle
                </button>
              </li>
            </ul>
          </div>

          {/* Col 3 - Support */}
          <div data-id="element-882">
            <h4 className="font-bebas text-xl text-white mb-6" data-id="element-883">SUPPORT</h4>
            <ul className="space-y-3 font-inter text-sm text-text-dimmed" data-id="element-884">
              <li data-id="element-885">
                <a href="#" className="hover:text-acid-green transition-colors" data-id="element-886">
                  FAQ
                </a>
              </li>
              <li data-id="element-887">
                <button onClick={e => {
                e.preventDefault();
                setShowShippingPolicy(true);
              }} className="hover:text-acid-green transition-colors text-left" data-id="element-888">
                  Shipping Info
                </button>
              </li>
              <li data-id="element-889">
                <button onClick={e => {
                e.preventDefault();
                setShowWarrantyPolicy(true);
              }} className="hover:text-acid-green transition-colors text-left" data-id="element-890">
                  Warranty Policy
                </button>
              </li>
              <li data-id="element-891">
                <button onClick={e => {
                e.preventDefault();
                setShowReturnsPolicy(true);
              }} className="hover:text-acid-green transition-colors text-left" data-id="element-892">
                  Returns & Exchanges
                </button>
              </li>
              <li data-id="element-893">
                <button onClick={e => {
                e.preventDefault();
                setShowContactPolicy(true);
              }} className="hover:text-acid-green transition-colors text-left" data-id="element-894">
                  Contact Us
                </button>
              </li>
              <li className="pt-2" data-id="element-895">
                <a href="tel:+18000000000" className="text-acid-green font-bebas text-lg tracking-wider" data-id="element-896">
                  +1 (800) 000-0000
                </a>
              </li>
            </ul>
          </div>

          {/* Col 4 - Company */}
          <div data-id="element-897">
            <h4 className="font-bebas text-xl text-white mb-6" data-id="element-898">COMPANY</h4>
            <ul className="space-y-3 font-inter text-sm text-text-dimmed" data-id="element-899">
              <li data-id="element-900">
                <a href="#" className="hover:text-acid-green transition-colors" data-id="element-901">
                  Our Mission
                </a>
              </li>
              <li data-id="element-902">
                <a href="#" className="hover:text-acid-green transition-colors" data-id="element-903">
                  Why We Built This
                </a>
              </li>
              <li data-id="element-904">
                <a href="#" className="hover:text-acid-green transition-colors" data-id="element-905">
                  For Teams & Wholesale
                </a>
              </li>
              <li data-id="element-906">
                <button onClick={e => {
                e.preventDefault();
                setShowPrivacyPolicy(true);
              }} className="hover:text-acid-green transition-colors text-left" data-id="element-907">
                  Privacy Policy
                </button>
              </li>
              <li data-id="element-908">
                <button onClick={e => {
                e.preventDefault();
                setShowTermsPolicy(true);
              }} className="hover:text-acid-green transition-colors text-left" data-id="element-909">
                  Terms of Service
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-black/50 py-5 px-6 md:px-12 border-t border-dark-3 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-910">
        <div className="font-inter text-xs text-text-dimmed text-center md:text-left flex items-center gap-2 flex-wrap justify-center" data-id="element-911">
          <span data-id="element-912">
            © 2025 BLACKOUT UNIT™ | blackoutunit.com | All Rights Reserved
          </span>
          <FlagIcon className="w-4 h-3" data-id="element-913" />
        </div>
        <div className="flex gap-2" data-id="element-914">
          {['VISA', 'MC', 'AMEX', 'PAYPAL', 'SHOP PAY', 'APPLE PAY'].map(pay => <div key={pay} className="bg-dark-1 border border-dark-3 px-2 py-1 text-[9px] font-barlow text-text-dimmed rounded-sm" data-id="element-915">
                {pay}
              </div>)}
        </div>
      </div>
    </footer>;
};